import { DataMainBoardResponse } from '../depreciation/types';

/**
 * 現設置店舗でフィルタリングした基板番号別データを返す
 *
 * @param dataMainBoard 基板番号別データ
 * @param currentHallNamesFilter 選択された現設置店舗名の配列（空配列の場合は全件表示）
 * @returns フィルタリングされた基板番号別データ
 */
export const dataMainBoardFilteredByCurrentHall = (
  dataMainBoard: DataMainBoardResponse,
  currentHallNamesFilter: string[] | undefined
): DataMainBoardResponse => {
  if (!currentHallNamesFilter?.length) {
    return dataMainBoard;
  }

  const { columns, rows } = dataMainBoard.data;

  // 現設置店舗列のインデックスを取得
  const currentHallNameColumnIndex = columns.findIndex(
    (column) => column.code === 'currentHallName'
  );

  if (currentHallNameColumnIndex === -1) {
    // 現設置店舗列が存在しない場合はフィルタリングしない
    return dataMainBoard;
  }

  // 選択された現設置店舗名に一致する行のみをフィルタリング
  const currentHallNamesSet = new Set(currentHallNamesFilter);
  const filteredRows = rows.filter((row) => {
    const currentHallName = row.data.at(currentHallNameColumnIndex)?.value;
    if (currentHallName === undefined) {
      return false;
    }
    return currentHallNamesSet.has(currentHallName); // O(1)
  });

  return {
    ...dataMainBoard,
    data: {
      ...dataMainBoard.data,
      rows: filteredRows,
    },
  };
};
